import { AlertTriangle, CheckCircle2, Info, XCircle } from 'lucide-react'
import { createElement } from 'react'
import { toast as sonnerToast } from 'sonner'

export const toast = {
  success(message, options = {}) {
    return sonnerToast.success(message, {
      icon: createElement(CheckCircle2, { className: 'size-4' }),
      ...options,
    })
  },
  error(message, options = {}) {
    return sonnerToast.error(message, {
      icon: createElement(XCircle, { className: 'size-4' }),
      ...options,
    })
  },
  info(message, options = {}) {
    return sonnerToast.info(message, {
      icon: createElement(Info, { className: 'size-4' }),
      ...options,
    })
  },
  warning(message, options = {}) {
    return sonnerToast.warning(message, {
      icon: createElement(AlertTriangle, { className: 'size-4' }),
      ...options,
    })
  },
}
